/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ItineraryBadgeOriginalValuesBadgeTypeEnum = {
    Default: 'default',
    Neutral: 'neutral',
    Info: 'info',
    Warning: 'warning',
    Critical: 'critical',
    Success: 'success'
};
/**
 * @export
 */
export const ItineraryBadgeOriginalValuesIconEnum = {
    Accommodation: 'accommodation',
    Alert: 'alert',
    Baggage: 'baggage',
    Check: 'check',
    Clock: 'clock',
    Diamond: 'diamond',
    Guarantee: 'guarantee',
    Info: 'info',
    Moon: 'moon',
    NoBaggage: 'no_baggage',
    SelfTransfer: 'self_transfer',
    Star: 'star',
    Visa: 'visa'
};
/**
 * Check if a given object implements the ItineraryBadgeOriginalValues interface.
 */
export function instanceOfItineraryBadgeOriginalValues(value) {
    return true;
}
export function ItineraryBadgeOriginalValuesFromJSON(json) {
    return ItineraryBadgeOriginalValuesFromJSONTyped(json, false);
}
export function ItineraryBadgeOriginalValuesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'badgeType': json['badge_type'] == null ? undefined : json['badge_type'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}
export function ItineraryBadgeOriginalValuesToJSON(json) {
    return ItineraryBadgeOriginalValuesToJSONTyped(json, false);
}
export function ItineraryBadgeOriginalValuesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'badge_type': value['badgeType'],
        'icon': value['icon'],
        'value': value['value'],
    };
}
